import toDate from './toDate'

export default (dateString, days) => {
  const date = toDate(dateString)
  date.setDate(date.getDate() + days)
  return date.toISOString()
}